const Tutorial = {
  navLeft: ({ state }) =>
    <path d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" fill='var(--app-red)' transform='scale(3)'/>,
  navRight: ({ state }) =>
    <path d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" fill='var(--app-red)' transform='scale(3)'/>,
};

export default Tutorial;